<script>
import { StoreCart } from "./StoreCart";



export let Data;
export let lang;
export let interval;
$: items = Object.values($StoreCart.items);
$: has_discount = $StoreCart.has_discount;
$: subtotal = $StoreCart.subtotal;
$: discounts = $StoreCart.discounts;
$: total = $StoreCart.total;

function getCurrency(item, index) {
    if (item && item.currency) {
        return item.currency[index];
    }
    return Data.currency[index];
}

</script>
<box-cart>
    <header>
        <h2 class="fw600 has-text-black font-size-14 has-text-left">
            {lang.forms.paymentAnyPlan.title}
        </h2>
    </header>
    <main class="box-cart padding-20 box">
        {#each items as item}
            <div class="is-flex is-justify-content-space-between is-align-items-center item-cart">
                <h3 class="has-text-black is-flex is-align-items-center">
                    <span class="fw600 font-size-14 has-text-left">
                        <span class="font-size-14">
                            Plan: {item.name}
                        </span>
                    </span>                                 
                </h3>
                <p class="fw600 font-size-14">
                    <span class="price-to-pay">
                        <span>
                            {getCurrency(item, 0)}
                        </span>
                        <span>
                            {item.prices[item.interval].current}
                        </span>
                        <span class="is-size-6">
                            {getCurrency(item, 1)}
                        </span>
                    </span>
                </p>
            </div>
        {/each}
        <!-- SUBTOTALES -->
        <div>
            <hr class="separtion-line">
        </div>
        <div class="fw600 has-text-black has-text-centered">
            <p class="has-text-black has-text-left is-flex is-justify-content-space-between">
                <span class="fw600 font-size-14">
                    {lang.forms.paymentAnyPlan.subtotal}
                </span>
                <span class="fw600">
                    <span class="price-interval">
                        <span>
                            {Data.currency[0]}
                        </span>
                        <span>
                            {subtotal[interval]}
                        </span>
                        <span class="is-size-6">
                            {Data.currency[1]}
                        </span>
                    </span>
                </span>
            </p> 
        </div>
        {#if has_discount}
            <div class="fw600 has-text-black has-text-centered">
                <p class="has-text-black has-text-left is-flex is-justify-content-space-between">
                    <span class="fw600 font-size-14">
                        {lang.forms.paymentAnyPlan.discounts}
                    </span>
                    <span class="fw600 font-size-14">
                        <span class="price-interval">
                            <span>
                                - {Data.currency[0]}
                            </span>
                            <span>
                                {discounts[interval]}
                            </span>
                            <span class="is-size-6">
                                {Data.currency[1]}
                            </span>
                        </span>
                    </span>
                </p> 
            </div>
        {/if}
        <!-- TOTAL -->
        <div>
            <hr class="separtion-line">
        </div>
        <div class="fw600 has-text-black has-text-centered">
            <p class="has-text-black has-text-left is-flex is-justify-content-space-between">
                <span class="fw600 font-size-14">
                    {lang.forms.paymentAnyPlan.total}
                </span>
                <span class="fw700 font-size-14 price-interval">
                    {Data.currency[0]}{total[interval]} {Data.currency[1]}
                </span>
            </p> 
        </div>
    </main>                
</box-cart>



<style>
.box-cart{
    background: var(--color-lightGrey);
}
.separtion-line{
    height: 1px;
    margin-top: 0.938rem;
    margin-bottom: 0.938rem;
    background: var(--color-extralightGrey);
}
.item-cart{
    margin: 0.75rem auto;
}
</style>